export default () =>
  Math.round(Math.random() * Date.now() * Math.random()).toString(36)
